import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { ConfirmationModalComponent } from '@shared/modals/confirmation-modal/confirmation-modal.component';
import { ConfirmationData } from '@shared/modals/confirmation-modal/shared/confirmation-data';
import { BaseStoreService } from '@shared/stores/base-store.service';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationModalStoreService extends BaseStoreService<ConfirmationData> {

  constructor(
    private ngbModal: NgbModal,
  ) {
    super();
  }

  show(data: ConfirmationData): NgbModalRef {
    this.current = data;

    return this.ngbModal.open(ConfirmationModalComponent);
  }
}
